module.exports = __webpack_public_path__ + "static/img/storageImg2.5d3f136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageImg2.png
// module id = 8uHg
// module chunks = 2